import styles from "./styles";
import {Image, Linking, SafeAreaView, ScrollView, Text, TouchableOpacity, View} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome5";
import React from "react";

export default function OfferDetails({navigation,route}){
    const onURLPress = (link) => {
        Linking.openURL(link);
    }
    return(
        <View style={styles.container}>
            <TouchableOpacity
                onPress={() => navigation.navigate(route.params.previousScreen,{
                    user:route.params.offer.user
                })}>
                <View style={{marginHorizontal:20, marginVertical:50,flexDirection:"row"}}>
                    <Icon
                        name="arrow-left"
                        color='#ddddd'
                        size={20}
                    />
                    <Text style={styles.text}>Back</Text>
                </View>
            </TouchableOpacity>
            <ScrollView>
                <SafeAreaView edges={['right', 'left']} style={{marginHorizontal:50}}>
                    <Image source={route.params.offer.imgsrc} style={styles.offerImg}></Image>
                    <Text style={styles.offerTitle}>{route.params.offer.name}</Text>
                    <Text style={styles.offerBody}>{route.params.offer.description}</Text>
                    <TouchableOpacity onPress={() => onURLPress(route.params.offer.link)} style={{justifyContent:'flex-end',marginLeft:20}}>
                        <Text style={[styles.shopNow,{color:route.params.appData.theme_colour, borderColor: route.params.appData.theme_colour}]}>Shop Now</Text>
                    </TouchableOpacity>
                </SafeAreaView>
            </ScrollView>
        </View>

    )
}